import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MatIcon } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaskitoDirective } from '@maskito/angular';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DecimalPipe, NgForOf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
import { Router } from '@angular/router';
import {
  mask_dinheiro,
  mask_mes_ano,
  mask_porcetagem_duas_casas_decimais,
} from '../../directives/mascaras';
import { FonteNotaInterface } from '../../shared/rodape-fonte-nota/fonte-nota.interface';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { RodapeFonteNotaComponent } from '../../shared/rodape-fonte-nota/rodape-fonte-nota.component';
import { DialogRestaurarValoresComponent } from '../../shared/dialog-restaurar-valores/dialog-restaurar-valores.component';
import { DialogPqrPadraoProfessoresComponent } from '../../shared/dialog-pqr-padrao-professores/dialog-pqr-padrao-professores.component';
import {
  CondicaoQualidadeStateService,
  MemoriaDeCalculoService,
} from '../../services';
import {
  MemoriaDeCalculoDto,
  PQRFormacaoJornadaRemuneracaoProfessoresDto,
  TipoNivelFormacaoDto,
} from '../../dtos';
import { QuantitativoDocentesService } from '../../services/quantitativo-docentes/quantitativo-docentes.service';
import { ValidacaoResult, ValidadorTela } from '../../interfaces/validacao.interface';
import { NumeroTotalDocentesDto } from '../../dtos/numero-total-docentes.dto';
import { PtBrNumberDirective } from '../../directives/pt-br-number.directive';
import { AnosReferenciasService } from '../../services/anos-referencias/anos-referencias.service';
import { AnosReferenciasDto } from '../../dtos/anos-referencias.dto';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

interface NumeroProfessoresPorcentagemDistribuicao {
  numeroProfessores: number;
  porcentagem: number;
  distribuicaoProfessores: number;
}

interface DadosTabelaCarreiraRemuneracao {
  numeroProfessoresPorcentagemDistribuicao: NumeroProfessoresPorcentagemDistribuicao;
  pqr: PQRFormacaoJornadaRemuneracaoProfessoresDto;
}

@Component({
  selector: 'app-carreira-remuneracao-professores',
  standalone: true,
  imports: [
    TabelaComponent,
    MatIcon,
    ReactiveFormsModule,
    FormsModule,
    NgForOf,
    MaskitoDirective,
    MatTooltipModule,
    RodapeFonteNotaComponent,
    MatIconButton,
    OnlyNumbersDirective,
    MenuSuspensoComponent,
    DecimalPipe,
    PtBrNumberDirective
  ],
  templateUrl: './carreira-remuneracao-professores.component.html',
  styleUrl: './carreira-remuneracao-professores.component.scss',
})
export class CarreiraRemuneracaoProfessoresComponent implements OnInit, ValidadorTela {
  @ViewChild('infoTooltip') infoTooltip!: MatTooltip;
  @ViewChild('menuTooltip') menuTooltip!: MatTooltip;

  anoCenso: number;
  anoPqr: number;
  distribuicaoNumeroProfesores: number = 0;
  numeroDeProfessoresPorNivel: number = 0;

  totalDocentes: NumeroTotalDocentesDto[] = [];

  totalDocentesCenso: number = 0;
  anoReferenciaCenso: number = 2020;

  protected readonly Object = Object;

  opcoesFormacao: TipoNivelFormacaoDto[] = [
    { codTipoNivelFormacao: 0, descricao: 'Selecione' },
    { codTipoNivelFormacao: 1, descricao: 'Médio' },
    { codTipoNivelFormacao: 2, descricao: 'Superior' },
    { codTipoNivelFormacao: 3, descricao: 'Especialização' },
    { codTipoNivelFormacao: 4, descricao: 'Mestrado' },
    { codTipoNivelFormacao: 5, descricao: 'Doutorado' },
  ];

  menuTooltipVisible = false;

  dadosTabela: DadosTabelaCarreiraRemuneracao[] = [];
  memoriaCalculoDto: MemoriaDeCalculoDto | undefined;
  total: number = 0;

  notasFonte: FonteNotaInterface[] = [
    {
      titulo: 'Notas',
      conteudos: [
        {
          numero: 1,
          descricao:
            'No nível de formação "Médio" foram somados os docentes com os ' +
            'seguintes níveis de formação: ‘Ensino Fundamental completo’, ' +
            '‘Ensino Fundamental incompleto’, ‘Ensino Médio’ e ‘Ensino Médio ' +
            'na modalidade normal’.',
        },
        {
          numero: 3,
          descricao:
            'A contagem do número de professores considera os profissionais ' +
            'informados no Censo Escolar nas funções de ‘Docente’ e de ‘Docente ' +
            'Titular’ - coordenador de tutoria (de módulo ou disciplina) – EaD, ' +
            'exercidas em escolas públicas. São considerados apenas os ' +
            'professores que atuam em turmas cujo tipo de atendimento não seja ' +
            'de Atividade Complementar ou de Atendimento Educacional ' +
            'Especializado (AEE).',
        },
      ],
    },
    {
      titulo: 'Fonte',
      conteudos: [
        {
          numero: 2,
          descricao:
            'Elaborado a partir dos microdados do Censo Escolar/INEP ' +
            '(arquivo Docentes) 2025',
        },
      ],
    },
  ];

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private dialogRestaurarValores: MatDialog,
    private dialogPqrPadraoProfessores: MatDialog,
    private memoriaCalculoService: MemoriaDeCalculoService,
    private quantitativoDocentesService: QuantitativoDocentesService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private anosReferenciasService: AnosReferenciasService,
    private featureFlagService: FeatureFlagService
  ) {
    let anosReferencias: AnosReferenciasDto | null = null;
    if (this.featureFlagService.funcionalidadeHabilitada('940-atualizacao-de-componentes-de-edicao-pqr')) {
      anosReferencias = this.anosReferenciasService.obterAnosReferenciasSnapshot();
    }
    this.anoCenso = anosReferencias?.anoCenso ?? 2025;
    this.anoPqr = anosReferencias?.anoPqr ?? 2026;
    this.notasFonte[1].conteudos[0].descricao = `Elaborado a partir dos microdados do Censo Escolar/INEP (arquivo Docentes) ${this.anoCenso}`;
  }

  async ngOnInit() {
    await this.buscarQuantitativoDocentes();

    if (this.condicaoQualidadeStateService.carregando.getValue()) {
      this.condicaoQualidadeStateService.carregando.subscribe(async () => {
        this.memoriaCalculoDto =
          await this.memoriaCalculoService.buscarMemoriaDeCalculoLocalizacao();
        this.buscarDadosTabela(
          this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresValores(),
        );
        return;
      });
    }

    this.memoriaCalculoDto =
      await this.memoriaCalculoService.buscarMemoriaDeCalculoLocalizacao();

    this.buscarDadosTabela(
      this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresValores(),
    );
  }

  async buscarQuantitativoDocentes(): Promise<void> {
    const totalDocentes = await this.quantitativoDocentesService
      .obterPorLocalizacao();

    this.totalDocentesCenso = totalDocentes.quantidade;
    this.anoReferenciaCenso = totalDocentes.ano;
  }

  buscarDadosTabela(dados: PQRFormacaoJornadaRemuneracaoProfessoresDto[]): void {
    const dadosClonados = JSON.parse(JSON.stringify(dados));

    this.dadosTabela = dadosClonados.map(
      (item: PQRFormacaoJornadaRemuneracaoProfessoresDto) => {
        const numeroProfessoresDistribuicao: NumeroProfessoresPorcentagemDistribuicao = {
          numeroProfessores: 0,
          porcentagem: 0,
          distribuicaoProfessores: item.distribuicaoNiveisCarreira ?? 0
        };

        return {
          numeroProfessoresPorcentagemDistribuicao: numeroProfessoresDistribuicao,
          pqr: item,
        };
      },
    );

    // Se o nível for Superior (código 2), usa os dados do censo
    // Se houver outros niveis discriminados, adicionar aqui
    this.dadosTabela.forEach(item => {
      if (item.pqr.tipoNivelFormacao.codTipoNivelFormacao === 2) {
        item.numeroProfessoresPorcentagemDistribuicao.numeroProfessores = this.totalDocentesCenso;

        if(!item.numeroProfessoresPorcentagemDistribuicao.porcentagem && item.numeroProfessoresPorcentagemDistribuicao.porcentagem!==0){
          item.numeroProfessoresPorcentagemDistribuicao.porcentagem = 100
        }

        if(!item.pqr.distribuicaoNiveisCarreira && item.pqr.distribuicaoNiveisCarreira!==0){
          item.pqr.distribuicaoNiveisCarreira = 0
        }

      }
    });

    this.total = this.totalDocentesCenso;
    this.calcularTotais();
  }

  private calcularTotais(): void {
    // Soma das porcentagens
    this.numeroDeProfessoresPorNivel = this.dadosTabela.reduce(
      (acc, item) => acc + (item.numeroProfessoresPorcentagemDistribuicao.porcentagem || 0),
      0,
    );

    // Soma das distribuições
    this.distribuicaoNumeroProfesores = this.dadosTabela.reduce(
      (acc, item) => acc + (item.pqr.distribuicaoNiveisCarreira || 0),
      0,
    );
  }

  atualizarDadosDoServicoDeEstado(): void {
    const dadosDto = this.dadosTabela.map(item => {
      const formacao = this.opcoesFormacao.find(
        f => f.codTipoNivelFormacao === item.pqr.tipoNivelFormacao.codTipoNivelFormacao
      );

      return {
        ...item.pqr,
        tipoNivelFormacao: formacao || item.pqr.tipoNivelFormacao
      };
    });

    this.calcularTotais()

    this.condicaoQualidadeStateService.setPQRFormacaoJornadaRemuneracaoProfessoresValores(dadosDto);
  }

  openDialogRestaurarValores(): void {
    const openedDialog = this.dialogRestaurarValores.open(
      DialogRestaurarValoresComponent,
      {
        panelClass: 'dialog-restaurar-valores',
        position: { top: '2%' },
      },
    );

    openedDialog.afterClosed().subscribe((result: any) => {
      if (result) {
        this.configurarValoresPadrao();
        this.toastr.success('Os valores foram restaurados', 'PQR!');
      }
    });
  }

  openDialogPqrValoresPadrao(): void {
    const dialogRef = this.dialogPqrPadraoProfessores.open(
      DialogPqrPadraoProfessoresComponent,
      {
        panelClass: 'dialog-pqr-padrao-professores',
        position: { top: '2%' },
      },
    );

    const dialogInstance =
      dialogRef.componentInstance as DialogPqrPadraoProfessoresComponent;
    dialogInstance.dadosTabela =
      this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresPadrao();
  }

  chamarAcao(acao: string) {
    if (acao === 'pqrDestaFuncionalidade') {
      this.pqrDestaFuncionalidade();
      return;
    }

    if (acao === 'restaurarValoresComBaseNoPqr') {
      this.restaurarValoresComBaseNoPqr();
      return;
    }

    if (acao === 'pqrCompletoEmNovaAba') {
      this.pqrCompletoEmNovaAba();
      return;
    }
  }

  pqrDestaFuncionalidade(): void {
    this.openDialogPqrValoresPadrao();
  }

  restaurarValoresComBaseNoPqr(): void {
    this.openDialogRestaurarValores();
  }

  pqrCompletoEmNovaAba(): void {
    const baseUrl = window.location.href.replace(this.router.url, '');
    const url = new URL('pqr', baseUrl).href;
    window.open(url, '_blank');
  }

  configurarValoresPadrao(): void {
    const padrao = JSON.parse(JSON.stringify(
      this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresPadrao()
    ));

    this.condicaoQualidadeStateService.setPQRFormacaoJornadaRemuneracaoProfessoresValores(padrao);
    this.buscarDadosTabela(padrao);
  }

  adicionarProfessores(): void {
    const sequencialProfessor: number = this.dadosTabela.length + 1;
    const novoProfessor: PQRFormacaoJornadaRemuneracaoProfessoresDto = {
      codPqrFormacaoJornadaRemuneracaoProfessores: sequencialProfessor,
      denominacao: `P${sequencialProfessor}`,
      tipoNivelFormacao: {
        codTipoNivelFormacao: 0,
        descricao: 'Selecione',
      },
      jornadaComInteracao: 0,
      jornadaSemInteracao: 0,
      jornadaTotal: 0,
      remuneracaoBrutaMensal: 0,
      mesAnoReferencia: '',
      distribuicaoNiveisCarreira: 0,
    };

    const novoProfessorTabela: DadosTabelaCarreiraRemuneracao = {
      pqr: novoProfessor,
      numeroProfessoresPorcentagemDistribuicao: {
        numeroProfessores: 0,
        porcentagem: 0,
        distribuicaoProfessores: 0,
      },
    };

    this.condicaoQualidadeStateService.setPQRFormacaoJornadaRemuneracaoProfessoresValores([
      ...this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresValores(),
      novoProfessor,
    ]);
    this.dadosTabela.push(novoProfessorTabela);
    this.calcularTotais();
  }

  excluiProfessores(id: number): void {
    this.dadosTabela = this.dadosTabela.filter(
      (professor) => professor.pqr.codPqrFormacaoJornadaRemuneracaoProfessores !== id,
    );
    const pqr = this.condicaoQualidadeStateService
      .getPQRFormacaoJornadaRemuneracaoProfessoresValores()
      .filter((professor) => professor.codPqrFormacaoJornadaRemuneracaoProfessores !== id);
    this.condicaoQualidadeStateService.setPQRFormacaoJornadaRemuneracaoProfessoresValores(pqr);

    this.calcularTotais();
  }

  criaMensagemInconsistencia(): string[] {
    const mensagens: string[] = [];

    // Verifica se há pelo menos um nível informado
    if (this.dadosTabela.length === 0) {
      mensagens.push('Nenhum nível / classe foi informado.');
    }

    // Verifica se alguma distribuição está fora do intervalo 0-100
    const professorInvalido = this.dadosTabela.find(professor =>
      professor.pqr.distribuicaoNiveisCarreira < 0 || professor.pqr.distribuicaoNiveisCarreira > 100
    );
    if (professorInvalido) {
      mensagens.push(
        `A distribuição do % de docentes por nível de formação da sequência ${professorInvalido.pqr.denominacao} deve estar entre 0 e 100.`
      );
    }

    if (this.distribuicaoNumeroProfesores !== 100) {
      mensagens.push(
        'A soma da distribuição do % de docentes por nível de formação deve ser igual a 100%.'
      );
    }

    this.dadosTabela.forEach((professor) => {
      if (!professor.pqr.denominacao || professor.pqr.denominacao.trim() === '') {
        mensagens.push(
          `A denominação da sequência ${professor.pqr.denominacao || 'não informada'} não foi informada.`
        );
      }

      if (professor.pqr.tipoNivelFormacao.codTipoNivelFormacao == 0) {
        mensagens.push(
          `O nível de formação da sequência ${professor.pqr.denominacao} não é válido. Selecione um valor.`,
        );
      }

      if (professor.pqr.remuneracaoBrutaMensal <= 0) {
        mensagens.push(
          `A remuneração bruta mensal da sequência ${professor.pqr.denominacao} deve ser um valor maior que 0.`,
        );
      }

      if (!professor.pqr.jornadaTotal || Number(professor.pqr.jornadaTotal) <= 0) {
        mensagens.push(
          `A jornada total (em horas) da sequência ${professor.pqr.denominacao} deve ser maior que zero.`
        );
      }

      const somaInteracao = professor.pqr.jornadaSemInteracao + professor.pqr.jornadaComInteracao;

      if (somaInteracao != 100) {
        mensagens.push(
          `A soma de "com interação" e "sem interação" da sequência ${professor.pqr.denominacao} deve ser 100%.`
        );
      }
    });

    return mensagens;
  }

  validar(): ValidacaoResult {
    const mensagens = this.criaMensagemInconsistencia();
    return {
      valido: mensagens.length === 0,
      mensagens: mensagens
    };
  }

  restaurarValoresPadrao(): void {
    this.configurarValoresPadrao();
  }


  openTooltips(): void {
    this.menuTooltipVisible = true;
    setTimeout(() => {
      this.infoTooltip.show();
      this.menuTooltip.show();
    }, 100);
  }

  closeTooltips(): void {
    this.menuTooltipVisible = false;
    setTimeout(() => {
      this.infoTooltip.hide();
      this.menuTooltip.hide();
    }, 100);
  }

  protected readonly mask_porcetagem_duas_casas_decimais =
    mask_porcetagem_duas_casas_decimais;
  protected readonly mask_mes_ano = mask_mes_ano;
  protected readonly mask_dinheiro = mask_dinheiro;

  ajustarPorcentagemComInteracao(professor: DadosTabelaCarreiraRemuneracao): void {
    const valor = Number(professor.pqr.jornadaSemInteracao) || 0;
    professor.pqr.jornadaComInteracao = Math.round((100 - valor) * 100) / 100;
    this.atualizarDadosDoServicoDeEstado();
  }

  ajustarPorcentagemSemInteracao(professor: DadosTabelaCarreiraRemuneracao): void {
    const valor = Number(professor.pqr.jornadaComInteracao) || 0;
    professor.pqr.jornadaSemInteracao = Math.round((100 - valor) * 100) / 100;
    this.atualizarDadosDoServicoDeEstado();
  }

  onMesAnoBlur(professor: DadosTabelaCarreiraRemuneracao, event: any): void {
    const mesAno = event.target.value.trim();

    if (!mesAno) {
      professor.pqr.mesAnoReferencia = '';
      this.atualizarDadosDoServicoDeEstado();
      return;
    }

    if (/^\d{2}\/\d{4}$/.test(mesAno)) {
      const [mes, ano] = mesAno.split('/');
      const mesNum = parseInt(mes, 10);

      if (mesNum >= 1 && mesNum <= 12) {
        professor.pqr.mesAnoReferencia = `${ano}-${mes}-01`;
        this.atualizarDadosDoServicoDeEstado();
      } else {
        professor.pqr.mesAnoReferencia = '';
      }
    } else if (mesAno.length > 0) {
      professor.pqr.mesAnoReferencia = '';
    }
  }

  formatarMesAnoParaExibicao(iso?: string): string {
    if (!iso) return '';

    // se já está no formato MM/YYYY, retorna direto
    if (/^\d{2}\/\d{4}$/.test(iso)) {
      return iso;
    }

    // converte ISO para MM/YYYY
    const data = iso.split('T')[0];
    const [ano, mes] = data.split('-');
    return ano && mes ? `${mes}/${ano}` : '';
  }

  onNivelFormacaoChange(prof: DadosTabelaCarreiraRemuneracao, cod: number): void {
    const sel = this.opcoesFormacao.find(f => f.codTipoNivelFormacao === Number(cod));
    if (sel) {
      prof.pqr.tipoNivelFormacao.codTipoNivelFormacao = sel.codTipoNivelFormacao;
      prof.pqr.tipoNivelFormacao.descricao = sel.descricao; // <- atualiza o objeto também
    }
    this.atualizarDadosDoServicoDeEstado();
  }

}

export function canDeactivateFn(
  component: CarreiraRemuneracaoProfessoresComponent
): Observable<boolean> | boolean {
  if (component.criaMensagemInconsistencia().length > 0) {
    return false;
  }
  return true;
}
